<template>
<v-container fluid class="pa-0">
    <v-toolbar class="elevation-2" height="48px">
        <v-btn icon href="/#/types/"><v-icon>mdi-arrow-left-thick</v-icon></v-btn>
        <v-toolbar-title >Fiche {{form.typ_id}} : {{form.typ_name}}</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
<!-- Formulaire -->
    <v-card fluid class="ma-2 pa-5 elevation-2">
        <v-layout row wrap>
        <v-flex xs6 class="pa-2">
            <v-select :items="entityTable" v-model="form.typ_entity"
                item-text="name" item-value="name" label="Statut" single-line :disabled="modify"
                @change="refreshTypeId()" >
            </v-select>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-select :items="parentTypes"  item-text="typ_name" item-value="typ_id" v-model="form.typ_id_parent" 
                label="Parent" single-line >   
            </v-select>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-text-field label="Nom" v-model="form.typ_name"></v-text-field>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-select :items="visibility" item-value="value" v-model="form.typ_visibility" label="Statut" single-line></v-select>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-text-field label="Identifiant type"    v-model="form.typ_id" :disabled="modify" ></v-text-field>
            <!-- <v-text-field label="Entité"  v-model="form.typ_entity" :disabled="modify"></v-text-field> -->
        </v-flex>
        <v-flex xs3 class="pa-2">
            <v-text-field label="Icone"    v-model="form.typ_icon" ></v-text-field>
        </v-flex>
        <v-flex xs3 class="pa-2">
            <v-menu offset-y content-class="elevation-0" style="z-index:900">
                <template v-slot:activator="{ on }">
                    <v-btn :color="form.typ_color" block dark class="mt-3" v-on="on">Couleur</v-btn>
                </template>
                <v-color-picker v-model="form.typ_color" class="ma-2 elevation-0" hide-canvas :swatches="swatches" show-swatches></v-color-picker>
            </v-menu>
        </v-flex>
        </v-layout>
    </v-card>
    <v-toolbar extended flat color="transparent" class="elevation-0" >
        <v-btn small dark color="cyan" @click="( $isAuthorized( 'TypePolicy', 'before' ) ? modify = false : false )">
            <v-icon dark>mdi-pencil</v-icon>Modifier l'identifiant
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" class="mr-2" :loading="saveProgress" @click.native="saveForm()" :disabled="(saveProgress || !validForm)">
        Enregistrer
        </v-btn>
        <v-btn color="primmary" href="/#/types/">
        Retour
        </v-btn>
    </v-toolbar>
</v-container>
</template>

<script>
import dateLocale from '../services/dateLocale';
import { cacheGetters, cacheMutations } from "../store/cache.module"

import { usrGetters }   from "../store/user.module"

export default {
    name: 'typesedit',
    props: ['contextStyle'],
    data: function () {
        return {
            saveProgress: false,         // Enregistrement en cours...
            loadingData: true,
            visibility: [
                {'value': 1,    'text': 'Visible'},
                {'value': 0,    'text': 'Désactivé'}
            ],
            modify: false,
            form:{
              typ_id:'', typ_tag: '', typ_entity: '',
              typ_name: '', typ_visibility: 1, typ_color: '#FF0000', typ_icon: null, 
              typ_created_at: '', typ_updated_at: '', typ_id_parent: ''
            },
            locDateFormat: dateLocale, // Format de date
            swatches: [
                ['#FF0000', '#AA0000', '#550000'], ['#FFFF00', '#AAAA00', '#555500'], ['#00FF00', '#00AA00', '#005500'],
                ['#00FFFF', '#00AAAA', '#005555'], ['#0000FF', '#0000AA', '#000055'],
            ],
            types : cacheGetters.getTypes(this.$route.params.typ_id.substring(0, 3)), //cacheGetters.getTypes('ACQ'),
            isAuthorized: usrGetters.getScopeRight,
        }
    },
    computed: {
        validForm(){
            let valid = true
            valid = (!this.form.typ_entity) ? false : valid
            return valid
        },
        progress () {
            return Math.min(100, this.form.usr_password.length * 12.5)
        },
        color () {
            return ['error', 'warning', 'success'][Math.floor(this.progress / 50)]
        },
        invalidFrom() {
            if( this.form.typ_entity.length > 0 && this.form.typ_name.length > 0 ){
                return false
            } else {
                return true
            }
        },
        parentTypes(){
            if( this.form.typ_id && this.form.typ_id.length > 3 ){
                return cacheGetters.getTypes(this.form.typ_id.substring(0, 3)).filter(function(item){
                    return !item.typ_id_parent
                })
            } else {
                return cacheGetters.getTypes('ACQ').filter(function(item){
                    return !item.typ_id_parent
                })
            }
        },
        entityTable() {
            let entities  = []
            let entObject = {}
            let types     = this.getCacheType()
            for( let group in types ){
                for( let type in types[group] ){
                    let typNum = ( parseInt( types[group][type].typ_id.substring(3, 5) ) + 1 ) + ""
                    let typId  = types[group][type].typ_id.substring(0, 3) + typNum.padStart(2, '0')
                    entObject[types[group][type].typ_entity] = { id: typId, name: types[group][type].typ_entity }
                }
            }
            for( let entity in entObject ){
                entities.push( entObject[entity] )
            }
            return entities
        }
    },
    mounted:function (){
        if( ( this.$route.params.typ_id ) && this.$route.params.typ_id.length > 3 ){
            this.modify = true
            this.getItem()
        } else {
            this.loadingData = false
        }
    },
    methods: {
        getItem(){
            this.$http.get( '/types/' + this.$route.params.typ_id ).then( (response) => {
                var prop
                for( prop in response.data.data ){
                    if( this.form[prop] !== undefined ){
                        this.form[prop] = response.data.data[prop] 
                    }
                }
            })
            .catch( (error) => {
                this.$root.$toast({ color: 'warning', text: error })
            })
        },
        async saveForm () {
            // Enregistrement du formulaire
            this.saveProgress = true
            if( this.$route.params.typ_id.length > 3 ){
                this.$http.put( '/types/' + this.$route.params.typ_id, this.form )
                .then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    this.getTypes()
                    this.$router.push({ path: '/types' })
                }).catch( (error) => {
                    this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                })
            } else {
                this.$http.post( '/types/', this.form )
                .then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    this.$router.push({ path: '/types' })
                }).catch( (error) => {
                    this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                })
            }
        },
        refreshTypeId(){
            this.form.typ_id = this.entityTable.find(x => x.name === this.form.typ_entity).id
            this.types = cacheGetters.getTypes(this.form.typ_id.substring(0, 3))
        },
        getTypes () {
            return new Promise( (resolve, reject) => {
                this.$http.get( '/types?per_page=false' ).then( (response) => {
                    let types = {}
                    response.data.data.forEach( (item) => {
                        if( types[ item.typ_id.substring(0, 3) ] == undefined ){
                            types[ item.typ_id.substring(0, 3) ] = {}
                        }
                        types[ item.typ_id.substring(0, 3)][item.typ_id] = item
                    })
                    cacheMutations.setTypes( types )
                    resolve('resolved')
                }).catch( () => { 
                    reject('failed')
                })
            })
        },
        getCacheType: cacheGetters.getTypes,
    },
    components: { }
}
</script>